(() => {
  const CFG = window.HR_CODE_PREISE;
  if (!CFG || window.__hrCodePreise) return;
  window.__hrCodePreise = true;

  const html = document.documentElement;
  const SITZUNG = 'hr-code';
  const AUSKUNFT = 'hr-code-auskunft:v1:';
  const FRISCH_MS = 15 * 60 * 1000;
  const NEU = 'data-hr-neu';
  const HAKEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  const STIL = /^(tag|zeile)$/.test(String(CFG.stil || '')) ? String(CFG.stil) : 'tag';
  const SCHMAL = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
  const zustand = new WeakMap();
  const folgeZustand = new WeakMap();
  const boxTeile = new WeakMap();
  const bearbeitet = new Map();
  let aktiv = [];
  let beobachter = null;
  let geplant = false;
  let pruefung = 0;
  let spaeterTimer = 0;
  let laeufe = [];

  const sitzung = {
    lies(k) {
      try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; }
    },
    schreib(k, v) {
      try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
    },
  };

  const wurzel = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const log = (...a) => { if (CFG.debug) console.log('[hr]', ...a); };

  function cookieCode() {
    const m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    try { return m ? decodeURIComponent(m[1]).trim() : ''; } catch (e) { return ''; }
  }

  const BETRAG = /(€\s?)?(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d{1,2}))?(\s?€|\s?EUR)?/g;

  function findeBetrag(text, nurZahl) {
    BETRAG.lastIndex = 0;
    let m;
    while ((m = BETRAG.exec(text)) !== null) {
      if (!m[0]) { BETRAG.lastIndex++; continue; }
      if (!nurZahl && !m[1] && !m[4]) continue;
      const ganz = parseInt(m[2].replace(/\./g, ''), 10);
      const dez = m[3] ? parseInt((m[3] + '0').slice(0, 2), 10) : 0;
      return { start: m.index, ende: m.index + m[0].length, cent: ganz * 100 + dez, vor: m[1] || '', nach: m[4] || '', mitDez: !!m[3] };
    }
    return null;
  }

  function formatiere(cent, muster, rund) {
    const c = rund ? Math.round(cent / 100) * 100 : Math.max(0, Math.round(cent));
    const ganz = Math.floor(c / 100);
    const dez = c % 100;
    const g = String(ganz).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const d = !rund && (muster.mitDez || dez) ? ',' + String(dez).padStart(2, '0') : '';
    return (muster.vor || '').replace(/ $/, '\u00a0') + g + d + (muster.nach || '').replace(/^ /, '\u00a0');
  }

  const zahl = (x) => String(Math.round(x * 100) / 100).replace('.', ',');

  function texte(el) {
    const out = [];
    const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = w.nextNode()) !== null) {
      if (n.parentElement && n.parentElement.closest('[' + NEU + ']')) continue;
      out.push(n);
    }
    return out;
  }

  const preisText = (el) => texte(el).map((n) => n.nodeValue).join('');

  function liesBetrag(el, nurZahl) {
    for (const n of texte(el)) {
      const b = findeBetrag(n.nodeValue, nurZahl);
      if (b) return Object.assign(b, { knoten: n });
    }
    return null;
  }

  function schreibeBetrag(el, cent, z, rund) {
    const b = liesBetrag(el, z.nurZahl);
    if (!b) return;
    const neu = b.knoten.nodeValue.slice(0, b.start) + formatiere(cent, b, rund) + b.knoten.nodeValue.slice(b.ende);
    if (neu !== b.knoten.nodeValue) {
      log('preis', el.className || el.tagName, b.knoten.nodeValue.trim(), '→', neu.trim());
      b.knoten.nodeValue = neu;
    }
    z.text = preisText(el);
  }

  function sichtbarIn(el, box) {
    for (let e = el; e && e !== box; e = e.parentElement) {
      if (e.classList.contains('hr-weg')) continue;
      if (getComputedStyle(e).display === 'none') return false;
    }
    return true;
  }

  function weg(el, an) {
    if (!el) return;
    if (an) el.classList.add('hr-weg');
    else el.classList.remove('hr-weg');
  }

  const sparZustand = new WeakMap();

  function spar(st, box, z, preis, ref, code) {
    const cfg = st.sparText;
    const betrag = ref - preis;
    const text = ((cfg.vorlageSchmal && SCHMAL.matches ? cfg.vorlageSchmal : cfg.vorlage) || 'Du sparst {betrag} · mit {code}').replace('{betrag}', formatiere(betrag, { vor: z.muster.vor, nach: z.muster.nach, mitDez: true })).replace('{code}', code);
    const el = box.querySelector(cfg.sel);
    if (el && !el.closest('[' + NEU + ']')) {
      let sz = sparZustand.get(el);
      if (!sz || (el.textContent !== sz.text && el.textContent !== sz.orig)) {
        sz = { orig: el.textContent, text: el.textContent };
        sparZustand.set(el, sz);
      }
      if (el.textContent !== text) el.textContent = text;
      sz.text = text;
      el.classList.add('hr-zeigen');
      teil(box, 'spar', false);
      return;
    }
    if (!cfg.neu) return;
    teil(box, 'spar', true, () => {
      const t = document.createElement('div');
      t.innerHTML = cfg.neu.html;
      const n = t.firstElementChild;
      n.setAttribute(NEU, 'spar');
      const ziel = cfg.neu.textIn ? n.querySelector(cfg.neu.textIn) : n;
      (ziel || n).textContent = text;
      return n;
    }, (n) => {
      const ort = cfg.neu.in ? box.querySelector(cfg.neu.in) : null;
      const nachEl = cfg.neu.nach ? box.querySelector(cfg.neu.nach) : null;
      if (ort && box.contains(ort)) ort.prepend(n);
      else if (nachEl && box.contains(nachEl)) danach(nachEl, n, box);
      else box.appendChild(n);
    });
  }

  function sparZurueck(st, box) {
    if (!st.sparText) return;
    const el = box.querySelector(st.sparText.sel);
    const sz = el && sparZustand.get(el);
    if (el && sz && el.textContent === sz.text && sz.text !== sz.orig) el.textContent = sz.orig;
    if (el) el.classList.remove('hr-zeigen');
  }

  function produktVon(st, box) {
    const q = st.produkt || 'link';
    if (q === 'link|seite') return produktVon({ produkt: 'link' }, box) || produktVon({ produkt: 'seite' }, box);
    if (q === 'seite') {
      const p = CFG.produkt;
      if (!p) return null;
      const feld = document.querySelector('form[id^="product-form-"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      const url = new URLSearchParams(location.search).get('variant');
      return { handle: p.handle, variante: String(url || (feld && feld.value) || p.variante || '') };
    }
    if (q.indexOf('attr:') === 0) {
      const name = q.slice(5);
      const t = box.closest('[' + name + ']') || box.querySelector('[' + name + ']');
      const v = t && t.getAttribute(name);
      return v ? { handle: v, variante: varianteIn(box) } : null;
    }
    const a = box.matches('a[href*="/products/"]') ? box : box.querySelector('a[href*="/products/"]') || box.closest('a[href*="/products/"]');
    const m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? { handle: decodeURIComponent(m[1]), variante: varianteIn(box) } : null;
  }

  function varianteIn(box) {
    const f = box.querySelector('[name="id"]');
    const d = box.closest('[data-variant-id]') || box.querySelector('[data-variant-id]');
    return String((f && f.value) || (d && d.getAttribute('data-variant-id')) || '');
  }

  function rabattiere(d, basis, prod) {
    if (d.bis && Date.now() > Date.parse(d.bis)) return null;
    if (d.mindestStueck > 1) return null;
    if (d.mindestCent && basis < d.mindestCent) return null;
    if (d.gilt !== 'alle') {
      const g = d.gilt || {};
      const h = !!prod && (g.produkte || []).indexOf(prod.handle) >= 0;
      const v = !!prod && !!prod.variante && (g.varianten || []).indexOf(prod.variante) >= 0;
      if (!h && !v) return null;
    }
    if (d.art === 'prozent') return basis - Math.floor((basis * d.wert) / 10000);
    if (d.art === 'betrag') return Math.max(0, basis - d.wert);
    return null;
  }

  function gesperrt(st, box) {
    for (const s of st.sperre || []) {
      for (const el of box.querySelectorAll(s.sel)) {
        if (!s.enthaelt || preisText(el).indexOf(s.enthaelt) >= 0) return true;
      }
    }
    return false;
  }

  function bester(st, box, basis) {
    let prod;
    let best = null;
    for (const a of aktiv) {
      if (a.d.gilt !== 'alle' && prod === undefined) prod = produktVon(st, box);
      const p = rabattiere(a.d, basis, prod);
      if (p == null || p >= basis) continue;
      if (!best || p < best.preis) best = { preis: p, a };
    }
    return best;
  }

  function ohneKlappStand(n) {
    return n.outerHTML.replace(/ hr-offen/g, '').replace(/aria-expanded="true"/g, 'aria-expanded="false"');
  }

  function teil(box, art, noetig, bauen, einsetzen) {
    let m = boxTeile.get(box);
    if (!m) { m = {}; boxTeile.set(box, m); }
    let alt = m[art];
    if (alt && (!alt.isConnected || !box.contains(alt))) alt = null;
    if (!noetig) {
      if (alt) alt.remove();
      m[art] = null;
      return;
    }
    const neu = bauen();
    if (alt && ohneKlappStand(alt) === ohneKlappStand(neu)) return;
    log('teil', art, box.className || box.tagName, alt ? 'ersetzt' : 'neu', neu.textContent);
    if (alt) alt.replaceWith(neu);
    else einsetzen(neu);
    m[art] = neu;
  }

  function teileWeg(box) {
    const m = boxTeile.get(box);
    if (!m) return;
    for (const art of Object.keys(m)) if (m[art]) m[art].remove();
    boxTeile.delete(box);
  }

  const davor = (ziel, n, box) => (ziel === box ? box.prepend(n) : ziel.before(n));
  const danach = (ziel, n, box) => (ziel === box ? box.append(n) : ziel.after(n));

  function wertText(d, muster) {
    return d.art === 'prozent' ? '−' + zahl(d.wert / 100) + '\u00a0%' : '−' + formatiere(d.wert, { vor: muster.vor, nach: muster.nach, mitDez: true });
  }

  function strichKnoten(st, text) {
    const n = document.createElement(st.altTag || 's');
    n.className = 'hr-alt' + (st.altKlasse ? ' ' + st.altKlasse : '');
    if (st.altStil) n.setAttribute('style', st.altStil);
    n.setAttribute(NEU, 'alt');
    n.textContent = text;
    return n;
  }

  function codeKnoten(code, wt, st) {
    const n = document.createElement('span');
    n.className = 'hr-code' + (st && st.klapp ? ' hr-code--klapp' : '');
    n.setAttribute(NEU, 'code');
    n.setAttribute('aria-label', 'mit Rabattcode ' + code + ', ' + wt);
    n.title = 'Rabattcode ' + code + ' ist aktiv';
    if (st && st.klapp) {
      n.setAttribute('role', 'button');
      n.setAttribute('aria-expanded', 'false');
      n.tabIndex = 0;
    }
    const i = document.createElement('span');
    i.className = 'hr-code__icon';
    i.innerHTML = HAKEN;
    const l = document.createElement('span');
    l.className = 'hr-code__label';
    l.textContent = (st && st.codeText) || CFG.codeText || 'mit Code';
    const c = document.createElement('span');
    c.className = 'hr-code__wert';
    c.textContent = st && st.klapp && code.length > 8 ? '' : code;
    n.append(i, l, c);
    return n;
  }

  function zeileKnoten(preisText, code, wt) {
    const n = document.createElement('span');
    n.className = 'hr-zeile';
    n.setAttribute(NEU, 'zeile');
    const p = document.createElement('span');
    p.className = 'hr-zeile__preis';
    p.textContent = preisText;
    n.append(p, codeKnoten(code, wt));
    return n;
  }

  function saleAn(st, box, pe, an) {
    if (!st.saleKlasse) return;
    const ziel = st.saleAn ? box.querySelector(st.saleAn) : pe;
    if (!ziel) return;
    const klassen = st.saleKlasse.split(' ').filter(Boolean);
    const merk = '__hrSale';
    if (an) {
      if (!ziel[merk]) ziel[merk] = klassen.filter((k) => !ziel.classList.contains(k));
      for (const k of ziel[merk]) ziel.classList.add(k);
    } else if (ziel[merk]) {
      for (const k of ziel[merk]) ziel.classList.remove(k);
      ziel[merk] = null;
    }
  }

  function zeige(st, box, pe, z, best) {
    const d = best.a.d;
    const code = best.a.code.toUpperCase();
    const preis = best.preis;
    const wt = wertText(d, z.muster);
    schreibeBetrag(pe, preis, z, st.rund);
    if (st.nurBetrag) {
      folge(st, box, z, preis, z.basis);
      attribute(st, box, preis);
      return;
    }
    box.classList.add('hr-box');
    if (st.ort) box.classList.add('hr-ort-' + st.ort);
    let reihe = (st.reihe && (box.matches(st.reihe) ? box : box.querySelector(st.reihe))) || (pe === box ? box : pe.parentElement);
    if (!reihe || !box.contains(reihe)) reihe = box;
    const codeZiel = () => [].concat(st.codeNach || []).map((x) => box.querySelector(x)).find((e) => e && box.contains(e) && sichtbarIn(e, box));
    if (STIL === 'zeile' && !st.ohneCode) {
      if (preisText(pe) !== z.orig) schreibeBetrag(pe, z.basis, z, st.rund);
      z.text = preisText(pe);
      pe.classList.remove('hr-preis');
      saleAn(st, box, pe, false);
      teil(box, 'alt', false);
      teil(box, 'code', false);
      teil(box, 'zeile', true, () => zeileKnoten(formatiere(preis, z.muster, st.rund) + (st.einheit || ''), code, wt), (n) => danach(reihe, n, box));
      folge(st, box, z, null, 0);
      attribute(st, box, null);
      return;
    }
    if (STIL === 'zeile') {
      zurueck(box, pe, z, st);
      return;
    }
    teil(box, 'zeile', false);
    pe.classList.add('hr-preis');
    const altEl = st.alt ? box.querySelector(st.alt) : null;
    const altBetrag = altEl && sichtbarIn(altEl, box) ? liesBetrag(altEl, false) : null;
    const ref = altBetrag && altBetrag.cent > z.basis ? altBetrag.cent : z.basis;
    const strich = !altBetrag && !st.ohneAlt && !st.einPreis;
    const ohne = formatiere(z.basis, z.muster, st.rund) + (st.einheit || '');
    if (st.einPreis && altEl) weg(altEl, true);
    for (const x of st.weg ? box.querySelectorAll(st.weg) : []) weg(x, true);
    saleAn(st, box, pe, strich || !!altBetrag || !!st.einPreis);
    const altZiel = st.altNach ? box.querySelector(st.altNach) : null;
    teil(box, 'alt', strich, () => strichKnoten(st, ohne), (n) => {
      if (altZiel && box.contains(altZiel)) danach(altZiel, n, box);
      else if (st.altPos === 'innen') pe.appendChild(n);
      else if (st.altPos === 'nach') danach(pe, n, box);
      else davor(pe, n, box);
    });
    teil(box, 'code', !st.ohneCode, () => codeKnoten(code, wt, st), (n) => {
      const ziel = codeZiel();
      if (ziel) danach(ziel, n, box);
      else if (st.codePos === 'innen') pe.appendChild(n);
      else reihe.appendChild(n);
    });
    if (st.sparText) spar(st, box, z, preis, ref, code);
    folge(st, box, z, preis, ref);
    attribute(st, box, preis);
  }

  function folge(st, box, z, preis, ref) {
    for (const f of st.folge || []) {
      box.querySelectorAll(f.sel).forEach((el) => {
        if (el.closest('[' + NEU + ']')) return;
        const jetzt = preisText(el);
        let proRegel = folgeZustand.get(el);
        if (!proRegel) {
          proRegel = new Map();
          folgeZustand.set(el, proRegel);
        }
        let fz = proRegel.get(f);
        if (f.enthaelt && (fz ? fz.orig : jetzt).indexOf(f.enthaelt) < 0) return;
        if (!fz || (jetzt !== fz.text && jetzt !== fz.orig)) {
          if (f.enthaelt && jetzt.indexOf(f.enthaelt) < 0) return;
          fz = { orig: jetzt, text: jetzt, art: f.art };
          if (f.art === 'prozent') {
            const m = jetzt.match(/(\d+(?:,\d+)?)(\s?%)/);
            if (!m) return;
            fz.prozent = m[1];
          } else {
            const b = liesBetrag(el, f.nurZahl);
            if (!b) return;
            fz.basis = b.cent;
            fz.nurZahl = f.nurZahl;
          }
          proRegel.set(f, fz);
        }
        let neu = null;
        if (preis != null) {
          if (f.art === 'rate') neu = Math.floor(preis / (f.teiler || 1));
          else if (f.art === 'plus') neu = fz.basis + (z.basis - preis);
          else if (f.art === 'gleich') neu = preis;
          else if (f.art === 'anteil') neu = z.basis > 0 ? Math.round((fz.basis * preis) / z.basis) : null;
          else if (f.art === 'prozent') neu = ref > 0 ? Math.round(((ref - preis) / ref) * 100) : null;
        }
        if (neu == null) {
          if (preisText(el) === fz.text && fz.text !== fz.orig) setzeFolge(el, fz, f, fz.art === 'prozent' ? fz.prozent : fz.basis, true);
          return;
        }
        setzeFolge(el, fz, f, neu, false);
      });
    }
  }

  function setzeFolge(el, fz, f, wert, zurueckAufOrig) {
    if (f.art === 'prozent') {
      for (const n of texte(el)) {
        const m = n.nodeValue.match(/(\d+(?:,\d+)?)(\s?%)/);
        if (!m) continue;
        const v = zurueckAufOrig ? wert : String(wert);
        const neu = n.nodeValue.slice(0, m.index) + v + n.nodeValue.slice(m.index + m[1].length);
        if (neu !== n.nodeValue) {
          log('folge', f.sel, n.nodeValue.trim(), '→', neu.trim());
          n.nodeValue = neu;
        }
        break;
      }
    } else {
      const b = liesBetrag(el, fz.nurZahl);
      if (b) {
        const neu = b.knoten.nodeValue.slice(0, b.start) + formatiere(wert, b, f.rund) + b.knoten.nodeValue.slice(b.ende);
        if (neu !== b.knoten.nodeValue) {
          log('folge', f.sel, b.knoten.nodeValue.trim(), '→', neu.trim());
          b.knoten.nodeValue = neu;
        }
      }
    }
    fz.text = preisText(el);
  }

  function attribute(st, box, preis) {
    for (const name of st.attribute || []) {
      const el = box.hasAttribute(name) ? box : box.querySelector('[' + name + ']');
      if (!el) continue;
      const key = '__hrAttr_' + name;
      if (el[key] == null || (el.getAttribute(name) !== el[key].text && el.getAttribute(name) !== el[key].orig)) el[key] = { orig: el.getAttribute(name), text: el.getAttribute(name) };
      const s = el[key];
      const b = findeBetrag(s.orig || '', false);
      if (!b) continue;
      const neu = preis == null ? s.orig : s.orig.slice(0, b.start) + formatiere(preis, b) + s.orig.slice(b.ende);
      if (el.getAttribute(name) !== neu) el.setAttribute(name, neu);
      s.text = neu;
    }
  }

  function zurueck(box, pe, z, st) {
    if (z && preisText(pe) === z.text && z.text !== z.orig) schreibeBetrag(pe, z.basis, z, st.rund);
    pe.classList.remove('hr-preis');
    saleAn(st, box, pe, false);
    sparZurueck(st, box);
    box.querySelectorAll('.hr-weg').forEach((e) => weg(e, false));
    teileWeg(box);
    box.classList.remove('hr-box');
    folge(st, box, z || { basis: 0 }, null, 0);
    attribute(st, box, null);
  }

  function zustandVon(st, pe) {
    const jetzt = preisText(pe);
    let z = zustand.get(pe);
    if (z && (jetzt === z.text || jetzt === z.orig)) return z;
    const b = liesBetrag(pe, st.nurZahl);
    if (!b) return null;
    z = { orig: jetzt, text: jetzt, basis: b.cent, muster: { vor: b.vor, nach: b.nach, mitDez: b.mitDez }, nurZahl: !!st.nurZahl };
    zustand.set(pe, z);
    return z;
  }

  function verarbeite() {
    geplant = false;
    if (!aktiv.length) return;
    for (const st of CFG.stellen || []) {
      let boxen;
      try { boxen = document.querySelectorAll(st.box); } catch (e) { continue; }
      boxen.forEach((box) => {
        if (box.closest('[' + NEU + ']')) return;
        if (st.ohne && box.closest(st.ohne)) return;
        const pe = st.preis ? (box.matches(st.preis) ? box : box.querySelector(st.preis)) : box;
        if (!pe) return;
        const z = zustandVon(st, pe);
        if (!z) return;
        bearbeitet.set(box, { st, pe });
        const best = gesperrt(st, box) ? null : bester(st, box, z.basis);
        if (best) zeige(st, box, pe, z, best);
        else zurueck(box, pe, z, st);
      });
    }
  }

  function planen() {
    if (geplant) return;
    const t = Date.now();
    laeufe = laeufe.filter((x) => t - x < 1000);
    laeufe.push(t);
    if (laeufe.length > 40) {
      bremse();
      return;
    }
    geplant = true;
    queueMicrotask(verarbeite);
  }

  function bremse() {
    if (beobachter) { beobachter.disconnect(); beobachter = null; }
    if (CFG.debug) console.warn('[hr] bremse');
    setTimeout(() => {
      laeufe = [];
      if (aktiv.length) an();
    }, 2000);
  }

  function an() {
    html.classList.add('hr-preise');
    verarbeite();
    if (!beobachter && document.body) {
      beobachter = new MutationObserver(planen);
      beobachter.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  function aus() {
    if (beobachter) { beobachter.disconnect(); beobachter = null; }
    bearbeitet.forEach((v, box) => zurueck(box, v.pe, zustand.get(v.pe), v.st));
    bearbeitet.clear();
    html.classList.remove('hr-preise');
  }

  async function auskunft(code) {
    const k = AUSKUNFT + code.toUpperCase();
    const c = sitzung.lies(k);
    if (c && Date.now() - c.t < FRISCH_MS) return c.d;
    const ersatz = () => (CFG.vorschau && CFG.vorschau[code.toUpperCase()]) || undefined;
    if (!CFG.endpunkt) return ersatz();
    try {
      const u = CFG.endpunkt + '?shop=' + encodeURIComponent(CFG.shop || location.hostname) + '&code=' + encodeURIComponent(code);
      const r = await fetch(u, { credentials: 'omit', headers: { Accept: 'application/json' } });
      if (!r.ok) return ersatz();
      const j = await r.json();
      if (!j || j.ok !== true) return ersatz();
      sitzung.schreib(k, { t: Date.now(), d: j.data || null });
      return j.data || null;
    } catch (e) {
      return ersatz();
    }
  }

  async function pruefe() {
    const nr = ++pruefung;
    let codes;
    try {
      const r = await fetch(wurzel() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      const cart = await r.json();
      codes = (cart.discount_codes || []).filter((c) => c && typeof c.code === 'string' && c.code.trim());
    } catch (e) {
      return;
    }
    const liste = await Promise.all(codes.map(async (c) => ({ code: c.code.trim(), passt: !!c.applicable, d: await auskunft(c.code.trim()) })));
    if (nr !== pruefung) return;
    const leisteWeg = liste.some((a) => a.d || a.d === undefined || a.passt);
    html.classList.toggle('hr-code-aktiv', leisteWeg);
    sitzung.schreib(SITZUNG, { an: leisteWeg, cookie: cookieCode() });
    aktiv = liste.filter((a) => a.d && (a.d.art === 'prozent' || a.d.art === 'betrag'));
    const stand = liste.map((a) => ({ code: a.code, art: a.d ? a.d.art : null, alle: !!(a.d && a.d.gilt === 'alle'), wert: a.d ? a.d.wert : null, freund: !!(a.d && a.d.freund) }));
    CFG.stand = stand;
    document.dispatchEvent(new CustomEvent('hr:code-preise', { detail: { codes: stand } }));
    hinweis(leisteWeg ? liste : []);
    bandHaken(leisteWeg ? liste : []);
    if (aktiv.length) an();
    else aus();
  }


  function hinweisText(a) {
    const d = a.d;
    if (!d) return 'aktiv · wird an der Kasse abgezogen';
    if (d.art === 'versand') return 'aktiv · kostenloser Versand';
    if (d.art !== 'prozent' && d.art !== 'betrag') return 'aktiv · wird an der Kasse abgezogen';
    const wert = d.art === 'prozent' ? '−' + zahl(d.wert / 100) + '\u00a0%' : '−' + formatiere(d.wert, { vor: '', nach: '\u00a0€', mitDez: true });
    return d.gilt === 'alle' ? 'aktiv · alle Preise schon ' + wert : 'aktiv · ' + wert + ' auf ausgewählte Artikel';
  }

  function hinweis(liste) {
    const art = CFG.hinweis;
    let el = document.getElementById('hr-hinweis');
    const a = liste.find((x) => x.d) || liste.find((x) => x.d === undefined);
    if (document.querySelector('[id^="EvStickyBuy-"], [id^="TlStickyBuy-"], [data-ak-sticky-kauf]')) html.classList.add('hr-mit-kaufleiste');
    if (!art || !a || !document.body) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('div');
      el.id = 'hr-hinweis';
      el.className = 'hr-hinweis hr-hinweis--' + art;
      el.setAttribute(NEU, 'hinweis');
      el.setAttribute('role', 'status');
      el.innerHTML = '<span class="hr-hinweis__icon">' + HAKEN + '</span><span class="hr-hinweis__code"></span><span class="hr-hinweis__text"></span>';
      const anker = CFG.hinweisNach ? document.querySelector(CFG.hinweisNach) : null;
      if (art === 'leiste' && anker) anker.after(el);
      else if (art === 'leiste') document.body.prepend(el);
      else document.body.appendChild(el);
    }
    el.querySelector('.hr-hinweis__code').textContent = a.code.toUpperCase();
    el.querySelector('.hr-hinweis__text').textContent = hinweisText(a);
  }

  function bandText(a) {
    const d = a.d;
    if (!d || (d.art !== 'prozent' && d.art !== 'betrag' && d.art !== 'versand')) return 'Wird an der Kasse abgezogen';
    if (d.art === 'versand') return 'Kostenloser Versand';
    const wert = d.art === 'prozent' ? zahl(d.wert / 100) + ' %' : formatiere(d.wert, { vor: '', nach: ' €', mitDez: true });
    return (d.gilt === 'alle' ? 'Alle Preise sind' : 'Ausgewählte Artikel sind') + ' bereits um ' + wert + ' reduziert';
  }

  async function codeEntfernen(code) {
    const cart = await (await fetch(wurzel() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })).json();
    const rest = (cart.discount_codes || []).map((c) => c.code).filter((c) => c && c.toLowerCase() !== code.toLowerCase());
    const r = await fetch(wurzel() + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: rest.join(',') }) });
    if (!r.ok) throw new Error('entfernen');
    const neu = await r.json();
    document.dispatchEvent(new CustomEvent('ev:code-angewendet'));
    if (typeof window.hrCodeEntfernt === 'function') window.hrCodeEntfernt(neu);
    await pruefe();
  }

  function bandHaken(liste) {
    const ziel = CFG.bandHaken ? document.querySelector(CFG.bandHaken) : null;
    let el = document.getElementById('hr-band-haken');
    const a = liste.find((x) => x.d) || liste.find((x) => x.d === undefined);
    if (!ziel || !a) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('div');
      el.id = 'hr-band-haken';
      el.className = 'hr-band-haken';
      el.setAttribute(NEU, 'hinweis');
      el.innerHTML = '<button type="button" class="hr-band-haken__knopf" aria-expanded="false"><span class="hr-hinweis__icon">' + HAKEN + '</span>Rabattcode aktiv</button><div class="hr-band-haken__mehr"><span class="hr-band-haken__text"></span><button type="button" class="hr-band-haken__weg">Code entfernen</button></div>';
      const knopf = el.querySelector('.hr-band-haken__knopf');
      const weg = el.querySelector('.hr-band-haken__weg');
      let zu = null;
      const schliesse = () => {
        if (el.classList.contains('is-laeuft')) return;
        clearTimeout(zu);
        el.classList.remove('is-offen');
        knopf.setAttribute('aria-expanded', 'false');
      };
      knopf.addEventListener('click', () => {
        const offen = el.classList.toggle('is-offen');
        knopf.setAttribute('aria-expanded', String(offen));
        clearTimeout(zu);
        if (offen) zu = setTimeout(schliesse, 6000);
      });
      weg.addEventListener('click', async () => {
        clearTimeout(zu);
        el.classList.add('is-offen', 'is-laeuft');
        weg.disabled = true;
        try {
          await codeEntfernen(el.dataset.code);
          weg.textContent = 'Code entfernen';
        } catch (e) {
          weg.textContent = 'Nicht geklappt, bitte noch einmal';
        }
        el.classList.remove('is-laeuft');
        weg.disabled = false;
        zu = setTimeout(schliesse, 6000);
      });
      el.addEventListener('mouseleave', schliesse);
      ziel.appendChild(el);
    }
    el.dataset.code = a.code;
    el.querySelector('.hr-band-haken__text').textContent = bandText(a);
  }

  function spaeter() {
    clearTimeout(spaeterTimer);
    spaeterTimer = setTimeout(pruefe, 350);
  }

  function cookieNachziehen(body) {
    const liste = JSON.parse(body).discount;
    const code = cookieCode().toLowerCase();
    if (typeof liste !== 'string' || !code) return;
    if (!liste.toLowerCase().split(',').map((c) => c.trim()).includes(code)) document.cookie = 'discount_code=; Path=/; Max-Age=0';
  }

  const fetchVorher = window.fetch;
  if (typeof fetchVorher === 'function') {
    window.fetch = function () {
      let neuPruefen = false;
      try {
        const eingabe = arguments[0];
        const init = arguments[1];
        const url = typeof eingabe === 'string' ? eingabe : (eingabe && eingabe.url) || '';
        const body = init && typeof init.body === 'string' ? init.body : '';
        const codeAmKorb = /\/cart\/update/.test(url) && /discount/.test(body);
        neuPruefen = /\/discount\//.test(url) || /\/cart\/clear/.test(url) || codeAmKorb;
        if (codeAmKorb) cookieNachziehen(body);
      } catch (e) {}
      const p = fetchVorher.apply(this, arguments);
      if (neuPruefen) p.then(spaeter, () => {});
      return p;
    };
  }
  document.addEventListener('shopify:cart:discount-update', (e) => {
    if (e && e.promise && typeof e.promise.then === 'function') e.promise.then(spaeter, spaeter);
    else spaeter();
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) pruefe(); });
  if (SCHMAL.addEventListener) SCHMAL.addEventListener('change', () => { if (aktiv.length) planen(); });

  function klappe(e) {
    const k = e.target && e.target.closest ? e.target.closest('.hr-code--klapp') : null;
    document.querySelectorAll('.hr-code--klapp.hr-offen').forEach((x) => {
      if (x === k) return;
      x.classList.remove('hr-offen');
      x.setAttribute('aria-expanded', 'false');
    });
    if (!k) return;
    e.preventDefault();
    e.stopPropagation();
    k.setAttribute('aria-expanded', String(k.classList.toggle('hr-offen')));
  }
  document.addEventListener('click', klappe, true);
  document.addEventListener('keydown', (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.classList && e.target.classList.contains('hr-code--klapp')) klappe(e);
  });

  html.classList.add('hr-stil-' + STIL);
  CFG.neuPruefen = pruefe;
  pruefe();
})();
